
import { Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { PlayerProfileStatsSummary, Stats } from '../models/stats';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Event } from '../models/event';

@Injectable()
export class StatsService {

  private apiUrl: string = environment.API_BASE_URL + '/stats';
  private playerProfileSummaryCache = new Map<string, Observable<PlayerProfileStatsSummary>>();

  constructor(private authHttp: HttpClient) { }

  private getRequestOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  }

  public getEventStats(originalEventId: string, includeAllTime: boolean = false): Observable<Stats[]> {
    const includeAllTimeParam = includeAllTime ? '?includeAllTime=true' : '';
    return this.authHttp.get<Stats[]>(`${this.apiUrl}/${originalEventId}${includeAllTimeParam}`, this.getRequestOptions());
  }

  public getPlayerProfileSummary(playerId: string): Observable<PlayerProfileStatsSummary> {
    if (!playerId) {
      return of(null);
    }

    const cachedSummary = this.playerProfileSummaryCache.get(playerId);
    if (cachedSummary) {
      return cachedSummary;
    }

    const summaryRequest = this.authHttp.get<PlayerProfileStatsSummary>(`${this.apiUrl}/player/${playerId}/summary`, this.getRequestOptions())
      .pipe(shareReplay(1));
    this.playerProfileSummaryCache.set(playerId, summaryRequest);
    return summaryRequest;
  }

  public cachePlayerProfileSummary(summary: PlayerProfileStatsSummary): void {
    if (!summary || !summary.playerId) {
      return;
    }
    this.playerProfileSummaryCache.set(summary.playerId, of(summary));
  }

  public recalculateStatsForEvent(originalEventId: string): Observable<Event> {
    return this.authHttp.post<Event>(`${this.apiUrl}/recalculate/${originalEventId}`, 'somestupidstring', this.getRequestOptions());
  }
}
